import React, {useEffect,useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {StoreContext} from "../stores/context";

import 'rc-slider/assets/index.css';
import SliderDataRow from "./SliderDataRow";
import SliderRow from "./SliderRow";


export default observer((props) => {
  const store = useLocalObservable(() => ({some_prop: ''}));
  const rootStore = useContext(StoreContext);

  useEffect(() => {
    // mount
    return () => {
      // unmount
    }
  }, []);

  if(!rootStore.tarif.inited) {
    rootStore.loadTarifs();
    return null;
  }

  const tarif=rootStore.tarif.data;
  return (
    <div>

      <div className="pbottom25">
        <SliderDataRow max={100} step={1} title={"Email-уведомления"} tooltip={`Бесплатно ${tarif.free_emails} email в день. Далее ${tarif.per_1_email} руб. за емайл.`} code={"emails"}/>
      </div>
      <div className="pbottom25">
        <SliderDataRow max={10000} step={100} title={"Используемое место под файлы "} tooltip={`Бесплатно ${tarif.free_mb}Мб. Далее ${tarif.per_100_mb} руб. за 100Мб.`} code={"storage"}/>
      </div>
      <div className="pbottom25">
        <SliderDataRow max={100000} step={100} title={"Хранимые записи"} tooltip={`Бесплатно ${tarif.free_rows} записей. Далее ${tarif.per_100_rows} руб. за 100 записей.`} code={"rows"}/>
      </div>
      <div className="pbottom25">
        <SliderDataRow max={50000} step={1000} title={"Количество показов форм"} tooltip={`Бесплатно ${tarif.free_renders} записей. Далее ${tarif.per_10_renders} руб. за 10 показов.`} code={"renders"}/>
      </div>
      <div className="pbottom25">
        <SliderDataRow min={2} max={100} step={1} title={"Компоненты форм"} tooltip={`Бесплатно ${tarif.free_fields} компонентов. Далее ${tarif.per_1_field} руб. за компонент.`} code={"fields"}/>
      </div>
      <div className="pbottom25">
        <SliderDataRow min={1} max={30} step={1} title={"Пользователей с доступом"} tooltip={`Бесплатно ${tarif.free_users} пользователь. Далее ${tarif.per_1_user} руб. за дополнительного пользователя.`} code={"access"}/>
      </div>
      <div className="pbottom25">
        <SliderDataRow max={10} step={1} title={"Блок с логикой"} tooltip={`${tarif.per_1_logics} руб. за блок с логикой.`} code={"logics"}/>
      </div>
      <div className="pbottom25">
        <SliderDataRow max={10} step={1} title={"Интеграции"} tooltip={`${tarif.per_1_app} руб. за интеграцию.`} code={"apps"}/>
      </div>

      <SliderRow title="">
        <div className="fs22">
          <strong>ИТОГО: {rootStore.calcCost().summ.toFixed(2)}  руб./день</strong> <span className="wsnw">({rootStore.calcCost().summ_month} руб. в месяц)</span>
        </div>
      </SliderRow>

    </div>
  )

});